import { useLayoutEffect, useState } from "react"

import eventStyle from "./event.module.css"
import registerStyle from "../register/register.module.css"

import { search_event } from "./setup"
import { event_load } from "../data"
import Loading from "../loading/loading"


export default function Event(props) {

    const eventList = window.EventManager.eventList
    const selectEevent = window.EventManager.selectEevent
    const Set_selectEvent = window.EventManager.Set_selectEvent

    const [eventLoading, Set_eventLoading] = useState(true)
    const [searchWord, Set_searchWord] = useState('')

    useLayoutEffect(() => {
        get_data()
    }, [])

    async function get_data() {
        Set_eventLoading(true)
        const result = await event_load()
        if(result) {
            Set_eventLoading(false)
        }
    }

    return(
        <div
            id="list"
            className={eventStyle['eventWrap']}
        >
            <div
                style={{
                    display: "flex",
                    marginBottom: "5px"
                }}
            >
                <div className={eventStyle['input_text']}>
                    <input
                        type="text"
                        name="search_word"
                        placeholder="행사명 또는 설명"
                        value={searchWord}
                        onChange={(e) => Set_searchWord(e.currentTarget.value)}
                    ></input>
                </div>
                <button
                    type="button"
                    className={eventStyle['button']}
                    onClick={() => search_event({
                        searchWord: searchWord,
                        Set_eventLoading: Set_eventLoading
                    })}
                >검색</button>
            </div>

            <div className={eventStyle.eventList}>
                <Loading
                    loading={eventLoading}
                ></Loading>

                {eventList
                .map((value, index) => {
                    return(
                        <div
                            key={index}
                            className={
                                selectEevent !== null && selectEevent['id'] === value['id']
                                ? `${eventStyle.eventButton} ${eventStyle.selected}`
                                : eventStyle.eventButton
                            }
                            id={value['id']}
                            onClick={() => Set_selectEvent({
                                'id': value['id'],
                                'name': value['name']
                            })}
                        >
                            <div
                                style={{
                                    display: "flex",
                                    alignItems: "center",
                                }}
                            >
                                <div
                                    style={{
                                        marginRight: "5px"
                                    }}
                                >{value['name']}</div>
                                <div
                                    style={{
                                        fontSize: "10px",
                                        color: "gray"
                                    }}
                                >
                                    {function() {
                                        const description = value['description']
                                        if(description) {
                                            return `(${description})`
                                        }
                                        else {
                                            return ''
                                        }
                                    }()}
                                </div>
                            </div>
                            <div>
                                {function() {
                                    const w = new Date(value['updatedAt'].toString())
                                    return w.toLocaleString("ko-KR")
                                }()}
                            </div>
                        </div>
                    )
                })}

                {eventList.length === 0 &&
                    <div
                        style={{
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            width: "100%",
                            height: "100%"
                        }}
                    >행사가 없습니다.</div>
                }
            </div>
        </div>
    )
}